const React = require('react');

const internals = {};

module.exports = function WeeklyHonorIcon({ rank }) {

    const podium = rank >= 1 && rank <= 3;
    const tier = internals.tiers.find((cutoff) => rank <= cutoff) || rank;
    const colors = internals.colors[rank] || ['#eee8fa', '#7960c8', '#59408e'];
    return <svg viewBox='0 0 40 48' width='28' height='34' aria-hidden='true' focusable='false' style={{ verticalAlign: 'middle', flexShrink: 0 }}>
        {podium ? <>
            <path d='M8 2h9l9 18-8 4z' fill='#7960c8' />
            <path d='M23 2h9L22 24l-8-4z' fill='#b8a3e1' />
            <circle cx='20' cy='30' r='15' fill={colors[0]} stroke={colors[2]} strokeWidth='2' />
            <circle cx='20' cy='30' r='11.5' fill='none' stroke={colors[1]} strokeWidth='2' />
            <text x='20' y='36' textAnchor='middle' fontFamily='inherit' fontWeight='700' fontSize='18' fill={colors[2]}>{rank}</text>
        </> : <>
            <path d='m10 30-4 16 9-3 5 4 5-4 9 3-4-16z' fill={colors[1]} />
            <path d='m20 2 5 4 6 1 2 6 5 5-2 6 1 7-6 3-4 5-7-1-7 1-4-5-6-3 1-7-2-6 5-5 2-6 6-1z' fill={colors[0]} stroke={colors[2]} strokeWidth='1.5' />
            <circle cx='20' cy='21' r='12' fill='white' stroke={colors[1]} />
            <text x='20' y='18' textAnchor='middle' fontFamily='inherit' fontWeight='700' fontSize='6' fill={colors[2]}>TOP</text>
            <text x='20' y='29' textAnchor='middle' fontFamily='inherit' fontWeight='700' fontSize={tier >= 1000 ? 9 : 12} fill={colors[2]}>{tier}</text>
        </>}
    </svg>;
};

internals.tiers = [10, 25, 50, 100, 250, 500, 1000];
internals.colors = {
    1: ['#fff2a3', '#e9b92f', '#ad7713'],
    2: ['#f5faff', '#b2c3d5', '#77899e'],
    3: ['#ffe0bd', '#cf935d', '#955b32']
};
